export const DELETE_FOLDER_MESSAGE = 'Deleting this folder will move all its files and subfolders up one level.';
export const DELETE_FOLDER_TITLE = 'Are you sure you want to permanently delete this folder?';
export const EDIT_FOLDER_LABEL = 'Edit Folder';
export const DELETE_FOLDER_LABEL = 'Delete Folder';
export const EMPTY_FOLDER_MESSAGE = 'This folder is empty. You can use the upload button to add documents.';
